import sensitiveView from './sensitiveView';
import { setLang } from './all';

const KEY = 'zh';

const obj = setLang(KEY);

export default {
  sensitiveView: sensitiveView.zh,
  ...obj
};
